import { useTranslations } from 'next-intl'
import { z } from 'zod'

export const createZFindID = (
  t: ReturnType<typeof useTranslations<'find_id'>>,
) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, {
        message: t('name_error_empty_format'),
      }),
    phoneNumber: z
      .string()
      .trim()
      .min(1, {
        message: t('phone_number_error_empty_format'),
      }),
  })

export const ZFindIDResponse = z.object({
  username: z.string(),
})

export type TFindID = z.infer<ReturnType<typeof createZFindID>>
export type TFindIDResponse = z.infer<typeof ZFindIDResponse>
